export const irdaList = [
    {
        key: 'irda1',
        label: 'irda1',
        value: 0
    },
    {
        key: 'irda2',
        label: 'irda2',
        value: 1
    },
    {
        key: 'irda3',
        label: 'irda3',
        value: 2
    },
    {
        key: 'irda4',
        label: 'irda4',
        value: 3
    }
]